import React, { useState } from "react"
import pluralize from "pluralize"

import Modal from "../reusable/modal"

import { usePet } from "../../modules"

const EditDrugsQty = ({ prescription, visible, toggle, onPerform }) => {
    const [quantity, setQty] = useState(prescription?.quantity)

    const editPrescription = () => {
        prescription.quantity = quantity
        prescription.instructions = undefined

        onPerform(prescription)
        setTimeout(toggle, 300)
    }

    const [{ loading }, checkInStock] = usePet('inStock', {
        si: prescription?.ref?._id
     }, { load: { msg: "Checking inventory..." }, notify: true, callback: () => {
        editPrescription()
     }, manual: true })

    const editQty = e => setQty(e.target.value)
    
    return (
        <Modal
            w={ 400 }
            title="Edit Quantity"
            toggle={toggle}
            visible={visible}>       
            <div className="flex flex-wrap mt-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Total Amount
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        name="qty"
                        value={ quantity }
                        onChange={ editQty }
                        placeholder="30" />
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ checkInStock } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Prescribe { quantity * (prescription?.conversionRate ?? 1) } { pluralize(prescription?.ref?.issuedIn ?? '', (quantity * (prescription?.conversionRate ?? 1)) ?? 0) }</button>
            </div>
        </Modal>
    )
}   

export default EditDrugsQty